import ThemeWrapper from '@/components/ThemeWrapper';
import Heading from '@/components/Typography/Heading';
import { Link } from '@inertiajs/react';

interface AccessDeniedProps {
    reason?: string;
    required_permission?: string;
    user_groups: string[];
    is_authenticated: boolean;
}

export default function AccessDenied({
    reason = 'No tienes permiso para acceder a este recurso',
    required_permission: _required_permission,
    user_groups: _user_groups = [],
    is_authenticated = false,
}: AccessDeniedProps) {
    return (
        <ThemeWrapper>
            <div className="flex min-h-screen items-center justify-center bg-gray-50 px-4 py-12 sm:px-6 lg:px-8">
                <div className="w-full max-w-md space-y-8">
                    <div className="text-center">
                        <div className="mx-auto mb-6 flex h-24 w-24 items-center justify-center rounded-full bg-red-100">
                            <svg
                                className="h-12 w-12 text-red-600"
                                fill="none"
                                viewBox="0 0 24 24"
                                stroke="currentColor"
                            >
                                <path
                                    strokeLinecap="round"
                                    strokeLinejoin="round"
                                    strokeWidth={2}
                                    d="M12 9v2m0 4h.01m-6.938 4h13.856c1.54 0 2.502-1.667 1.732-3L13.732 4c-.77-1.333-2.694-1.333-3.464 0L3.34 16c-.77 1.333.192 3 1.732 3z"
                                />
                            </svg>
                        </div>

                        <Heading as="h1" className="mb-2 text-4xl">
                            Acceso Denegado
                        </Heading>

                        <p className="mb-8 text-xl text-gray-600">{reason}</p>

                        <div className="flex flex-col justify-center gap-3 sm:flex-row">
                            <Link
                                href="/"
                                className="inline-flex items-center justify-center rounded-md border border-transparent bg-blue-600 px-6 py-3 text-lg font-medium text-white transition-colors hover:bg-blue-700"
                            >
                                Ir al Inicio
                            </Link>
                            <Link
                                href="/my-account"
                                className="inline-flex items-center justify-center rounded-md border border-gray-300 bg-white px-6 py-3 text-lg font-medium text-gray-700 transition-colors hover:bg-gray-50"
                            >
                                Mi Cuenta
                            </Link>
                        </div>

                        {!is_authenticated && (
                            <p className="mt-6 text-base text-gray-600">
                                Por favor{' '}
                                <Link
                                    href="/auth/login/"
                                    className="font-medium text-blue-600 hover:text-blue-700"
                                >
                                    inicia sesión
                                </Link>{' '}
                                para acceder a este recurso.
                            </p>
                        )}
                    </div>
                </div>
            </div>
        </ThemeWrapper>
    );
}
